import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Message from 'element-ui/lib/message';
import App from "@/App.vue";
import VueGtag from "vue-gtag";
Vue.use(VueRouter);
const routes = [
    {
        path: "/",
        redirect: "/index"
    }, {
        path: "/userRequirement",
        meta: {
            requiresAuth: true,
            title: 'My Requests'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/user/userRequirement.vue")
    }, {
        path: "/login",
        meta: {
            top: false,
            buttom: false,
            title: 'Sign In'
        },
        beforeEnter(to, from, next) {
            // console.log(from);
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (store.state.isLoggedIn) {
                Message({
                    message: 'You are already signed in.',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: from ? from.path : '/index' })
                    }
                });
            } else {
                next()
            }
        },
        component: () => import("@/views/login.vue")
    }, {
        path: "/enrolment",
        meta: {
            top: false,
            buttom: false,
            title: 'Register'
        },
        component: () => import("@/views/enrolment.vue")
    }, {
        path: "/resetpass",
        meta: {
            top: false,
            buttom: false,
            title: 'Reset Password'
        },
        component: () => import("@/views/resetpass.vue")
    }, {
        path: "/index",
        meta: {
            top: true,
            buttom: true,
            title: 'Home'
        },
        component: () => import("@/views/index.vue")
    }, {
        path: "/AiDialogue",
        meta: {
            title: 'AI Chat',
            huancun: true
        },
        component: () => import("@/views/AiDialogue.vue")
    }, {
        path: "/provacyPolicy",
        meta: {
            top: true,
            buttom: true,
            title: 'Privacy Policy'
        },
        component: () => import("@/views/others/privacyPolicy.vue")
    }, {
        path: "/termsService",
        meta: {
            top: true,
            buttom: true,
            title: 'Terms of Service'
        },
        component: () => import("@/views/others/termsService.vue")
    }, {
        path: "/newsdetail/:id",
        name: "newsdetail",
        meta: {
            top: true,
            buttom: true,
            title: 'News'
        },
        component: () => import("@/views/others/newsdetail.vue")
    }, {
        path: "/paysuccess",
        meta: {
            top: false,
            buttom: false,
            title: 'Payment Successful'
        },
        component: () => import("@/views/others/paysuccess.vue")
    }, {
        path: "/payerror",
        meta: {
            top: false,
            buttom: false,
            title: 'Payment Failed'
        },
        component: () => import("@/views/others/payerror.vue")
    }, {
        path: "/detail/:id",
        name: "details",
        meta: {
            top: true,
            buttom: true,
            title: 'Book Details'
        },
        component: () => import("@/views/details/details.vue")
    }, {
        path: "/reader",
        meta: {
            top: false,
            buttom: false,
            title: 'Reading'
        },
        component: () => import("@/views/details/read.vue")
    }, {
        path: "/phoneReader",
        meta: {
            top: false,
            buttom: false,
            title: 'Reading'
        },
        component: () => import("@/views/details/appreader.vue")
    },
    {
        path: "/library",
        meta: {
            top: true,
            buttom: false,
            requiresAuth: true,
            allowGuest: true, // 游客凭访客会话(uuidtoken)即可进入书架/历史
            title: 'My Library'

        },
        component: () => import("@/views/library/library.vue")
    }, {
        path: "/user",
        meta: {
            top: true,
            buttom: false,
            requiresAuth: true,
            allowGuest: true, // 游客凭访客会话(uuidtoken)即可进入「我的」
            title: 'Account'
        },
        component: () => import("@/views/user/user.vue")
    }, {
        path: "/userinfo",
        meta: {
            top: true,
            buttom: false,
            requiresAuth: true,
            title: 'Messages'
        },
        component: () => import("@/views/user/userinfo.vue")
    }, {
        path: "/userSet",
        meta: {
            top: true,
            buttom: false,
            requiresAuth: true,
            title: 'Settings'
        },
        component: () => import("@/views/user/userSet.vue")
    },
    {
        path: "/classify",
        meta: {
            top: true,
            buttom: false,
            title: 'Categories'
        },
        component: () => import("@/views/classify/classify.vue")
    }, {
        path: "/rank",
        meta: {
            top: true,
            buttom: true,
            title: 'Rankings'
        },
        component: () => import("@/views/Rank/rank.vue")
    },
    {
        path: "/author/editor",
        name: "detail",
        meta: {
            title: 'Editor'

        },
        component: () => import("@/views/Author/BookEditor.vue")
    }, {
        path: "/authorhome",
        meta: {
            requiresAuth: true,
            author: true,
            title: 'Author Center'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/homepage.vue")
    }, {
        path: "/author/authorSet",
        meta: {
            requiresAuth: true,
            author: true,
            title: 'Author Settings'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/authorSet.vue")
    }, {
        path: "/author/bankInfo",
        meta: {
            requiresAuth: true,
            author: true,
            title: 'Author Info'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/bankInfo.vue")
    }, {
        path: "/author/Newcontent",
        meta: {
            requiresAuth: true,
            author: true,
            title: 'Author Content'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/content.vue")
    }, {
        path: "/author/newslist",
        meta: {
            requiresAuth: true,
            author: true,
            title: 'News List'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/message/newslist.vue")
    }, {
        path: "/author/informationlist",
        meta: {
            requiresAuth: true,
            author: true,
            title: 'Message List'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/message/informationlist.vue")
    }, {
        path: "/author/Income",
        meta: {
            requiresAuth: true,
            author: true,
            title: 'Income'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/income.vue")
    }, {
        path: "/author/Dshboard",
        meta: {
            requiresAuth: true,
            author: true,
            title: 'Dashboard'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/dshboard.vue")
    }, {
        path: "/author/OpenCourses",
        meta: {
            requiresAuth: true,
            author: true,
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/openCourses.vue")
    }, {
        path: "/author/WorkPlatform",
        meta: {
            requiresAuth: true,
            author: true,
            huancun: true,
            title: 'Works'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/workplattab/workbook.vue")
    }, {
        path: "/author/bookset",
        meta: {
            requiresAuth: true,
            author: true,
            title: 'Edit Book'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/workplattab/bookset.vue")
    }, {
        path: "/author/workdetail",
        meta: {
            requiresAuth: true,
            author: true,
            title: 'Work Details'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/workplattab/workdetail.vue")
    }, {
        path: "/author/blockchain",
        meta: {
            requiresAuth: true,
            author: true,
            title: 'Blockchain'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/blockchain/blockchain.vue")
    }
]

const scrollBehavior = (to, from, savedPosition) => {
    if (savedPosition) {
        return savedPosition
    } else {
        if (to.meta.huancun) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
}
const router = new VueRouter({
    mode: 'history',
    base: '/', // 不用 BASE_URL：生产 publicPath 指向 CDN，路由 base 必须保持源站根路径
    routes,
    scrollBehavior
})
Vue.use(VueGtag, {
    config: { id: "G-XPE65LPVCV" },
    appName: 'My application',
    pageTrackerScreenviewEnabled: true,
    pageTrackerExcludedRoutes: ['route_path_value', 'route_name_value'],
    pageTrackerTemplate(to) {
        return {
            page_title: to.meta.title,
            page_path: to.path
        }
    }
}, router);
router.beforeEach((to, from, next) => {
    // Google Ads转化跟踪 - 监听路由变化
    if (window.gtag) {
        // 注册页面转化跟踪
        if (to.path === '/enrolment') {
            // 发送页面浏览事件
            window.gtag('event', 'page_view', {
                page_title: 'Registration Page',
                page_path: '/enrolment'
            });
            
            // 发送转化事件 - 使用实际的转化标签
            window.gtag('event', 'conversion', {
                'send_to': 'AW-17434710827/ik6_CI7Ot_8aEKumwvlA'
            });
        }
        
        // 支付成功页面转化跟踪
        if (to.path === '/paysuccess') {
            // 发送页面浏览事件
            window.gtag('event', 'page_view', {
                page_title: 'Payment Success',
                page_path: '/paysuccess'
            });
            
            // 发送购买转化事件 - 使用购买转化标签
            window.gtag('event', 'conversion', {
                'send_to': 'AW-17434710827/j9jECJ7_sf8aEKumwvlA'
            });
        }
        
        // 详情页面转化跟踪
        if (to.path.startsWith('/detail/')) {
            // 发送页面浏览事件
            window.gtag('event', 'page_view', {
                page_title: 'Book Detail',
                page_path: to.path
            });
            
            // 发送详情页转化事件
            window.gtag('event', 'conversion', {
                'send_to': 'AW-17434710827/MJ_2CKXhwf8aEKumwvlA'
            });
        }
    }
    
    if (to.path === '/reader') {
        // 检测用户代理是否为移动设备（这里可以根据需要调整正则表达式）
        // iPadOS 13+ 的 Safari UA 伪装成 Macintosh，靠 maxTouchPoints 识别
        const isIPad = /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1;
        const isMobile = /iPhone|iPad|Android|Windows Phone/i.test(navigator.userAgent) || isIPad;
        if (isMobile) {
            // 如果是移动端，将重定向到 /phonereader，同时传递原有的查询参数
            next({
                path: '/phonereader',
                query: to.query
            });
            return; // 终止后续逻辑
        }
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // 真实登录(token) 放行；
        // 标记了 allowGuest 的页面，只要有访客会话(uuidtoken) 也放行——游客以访客身份浏览。
        const hasToken = localStorage.getItem('token');
        const guestOk = to.matched.some(record => record.meta.allowGuest) && localStorage.getItem('uuidtoken');
        if (!hasToken && !guestOk) {
            // 既非登录用户、又非允许游客的页面（如作者中心）→ 提示并去登录
            Message({
                message: 'Please log in first',
                type: 'warning',
                duration: 1000,
                onClose: () => {
                    next({
                        path: '/login',
                        query: { redirect: to.fullPath } // 也可以将路由信息作为查询参数传递
                    });
                }
            });

        } else {
            next(); // 确保一定要调用 next()
        }
    } else {
        next(); // 确保一定要调用 next()
    }
});
// 路由切换后同步浏览器标签标题（详情/阅读页可在组件内用书名覆盖）
router.afterEach((to) => {
    const baseTitle = 'RosettaNovel';
    const t = to.meta && to.meta.title;
    document.title = t ? `${t} | ${baseTitle}` : baseTitle;
});
export default router;